module.exports = __webpack_public_path__ + "static/IMG_7883-af93f98529584e2c4f49854f037f5f11.jpg";